import { createSimpleStore } from 'react-simple-reducer'
import api, { IQueryParams, ICounter } from '../api'
import { CursoModel } from '../models/CursoModel'
import { toast } from 'react-toastify'

export interface ICursosState {
  cursos: CursoModel[]
  loading: boolean
  query: IQueryParams
  cursosCount: number
}

export const initialState: ICursosState = {
  cursos: [],
  loading: false,
  query: { limit: 10, offset: 0 },
  cursosCount: 0,
}

const cursosStore = createSimpleStore(
  initialState,
  {
    requestAsync(state) {
      state.loading = true
    },
    requestError(state) {
      state.loading = false
    },
    cursosGetSuccess(state, payload: ICounter<CursoModel>) {
      state.cursos = payload.rows
      state.cursosCount = payload.count
      state.loading = false
    },
    cursosCreateOrUpdateSuccess(state, payload: CursoModel) {
      if (state.cursos.some((c) => c.id === payload.id)) {
        state.cursos = state.cursos.map((c) => (c.id === payload.id ? payload : c))
      } else {
        state.cursos.push(payload)
      }
    },
    cursosDeleteSuccess(state, payload: { id: number }) {
      state.cursos = state.cursos.filter((c) => +c.id !== payload.id)
    },
    setQueryParams(state, payload: IQueryParams) {
      state.query = { ...state.query, ...payload }
    },
  },
  {
    thunks: {
      updatePagination: (cursoId: number, query: IQueryParams) => (dispatch, getState) => {
        dispatch(cursosStore.actions.setQueryParams(query))
        cursosStore.thunks.cursosFetch()(dispatch, getState)
      },
      cursosFetch: () => async (dispatch, getState) => {
        dispatch(cursosStore.actions.requestAsync())
        try {
          const cursos = await api.Cursos.get(getState().query)
          dispatch(cursosStore.actions.cursosGetSuccess(cursos))
        } catch (error) {
          dispatch(cursosStore.actions.requestError())
          toast(error.response?.data?.message ?? 'Ocorreu um erro ao buscar os cursos')
        }
      },
      deleteCursos: (id: number) => async (dispatch) => {
        dispatch(cursosStore.actions.requestAsync())
        try {
          await api.Cursos.delete(id)
          dispatch(cursosStore.actions.cursosDeleteSuccess({ id }))
        } catch (error) {
          dispatch(cursosStore.actions.requestError())
          toast(error.response?.data?.message ?? 'Ocorreu um erro ao deletar o curso')
        }
      },
      createOrUpdateCursos: (values: Partial<CursoModel>) => async (dispatch) => {
        try {
          const curso = await api.Cursos.post(values)
          dispatch(cursosStore.actions.cursosCreateOrUpdateSuccess({ ...curso }))
        } catch (error) {
          dispatch(cursosStore.actions.requestError())
          toast(error.response?.data?.message ?? 'Ocorreu um erro ao salvar o curso')
        }
      },
    },
  }
)

export { cursosStore }
export const { Provider: CursosProvider, useDispatch: useCursosDispatch, useState: useCursosState, useSelector: useCursosSelector } = cursosStore